















import {Component, Mixins} from 'vue-mixin-decorator';
import {Route} from 'vue-router';
import {Inject} from 'inversify-props';

import {Profile} from '@/model/network/profile/Profile';

import {INetworkProfileService} from '@/services/network/INetworkProfileService';

import NetworkProfileEditor from '@/components/Networking/Profile/NetworkProfileEditor.vue';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {NetworkProfileEditor},
})
export default class NetworkProfile extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('INetworkProfileService'))
  private profileService!: INetworkProfileService;

  private profile: Profile | null = null;

  private async beforeRouteEnter(to: Route, from: Route, next: any) {
    try {
      const profile = await this.profileService.read(to.params.id);
      next((vm: NetworkProfile) => vm.profile = profile);
    } catch {
      next();
    }
  }

  private async refresh(): Promise<void> {
    this.logger.debug(`Refreshing data...`);

    try {
      this.profile = await this.profileService.read(this.$route.params.id);
    } catch (error) {
      Notify.Error(this.logger, `Could not get profile data`, error);
    }
  }

  private async save(): Promise<void> {
    this.logger.debug(`Saving data...`);
    if (!this.profile) {
      return;
    }

    try {
      await this.profileService.update(this.$route.params.id, this.profile);
    } catch (error) {
      Notify.Error(this.logger, `Could not save profile data`, error);
    }
  }

  private async deleteProfile(): Promise<void> {
    try {
      await this.profileService.delete(this.$route.params.id);
      this.$router.go(-1);
    } catch (error) {
      Notify.Error(this.logger, `Could not delete profile`, error);
    }
  }

  private async connect(): Promise<void> {
    this.logger.debug(`Connecting...`);

    try {
      await this.profileService.connect(this.$route.params.id);
    } catch (error) {
      Notify.Error(this.logger, `Could not connect profile`, error);
    }
  }
}
